'use client'

import type { Position } from '@fukku/tooltip/Tooltip'
import cx from 'classix'
import dynamic from 'next/dynamic'
import { useRef } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'

import animationStyles from '../../MotionAnimations.module.css'
import focusStyle from '../A11y/TabFocus.module.css'
import styles from './InfoTooltip.module.css'

const IconInfoL = dynamic(() =>
	import('icons/components/IconInfoL').then((mod) => mod.IconInfoL)
)

const Tooltip = dynamic(() =>
	import('@fukku/tooltip/Tooltip').then((mod) => mod.Tooltip)
)

interface InfoTooltipProps {
	readonly title: string
	readonly inverse: boolean
	readonly showInfo: boolean
	readonly infoText: string
	readonly className?: string
	readonly position?: Position
}

export function InfoTooltip({
	title,
	inverse,
	showInfo,
	infoText,
	className,
	position = 'top',
}: InfoTooltipProps) {
	const boundaryRef = useRef(null)

	if (!showInfo) {
		return <></>
	}

	return (
		<div ref={boundaryRef} className={cx(className, styles.boundary)}>
			<Tooltip
				position={position}
				content={<p>{infoText}</p>}
				boundary={boundaryRef}
			>
				<button
					type='button'
					title={title}
					className={cx(
						animationStyles.opacityFadeIn,
						styles.infoIconButton,
						applyStylesIf(inverse, styles.inverse),
						focusStyle.bannerCtaFocus
					)}
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
					}}
				>
					<IconInfoL />
				</button>
			</Tooltip>
		</div>
	)
}
